import { UserAppointmentReadiness } from '@headway/api/models/UserAppointmentReadiness';
import { UserApi } from '@headway/api/resources/UserApi';
import {
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@headway/shared/react-query';

export const getUseUserAppointmentReadinessQueryKey = (
  userId: number | undefined
): QueryKey => ['UserAppointmentReadiness', userId];

export const useAppointmentReadiness = (
  userId: number,
  providerId?: number,
  options?: UseQueryOptions<UserAppointmentReadiness | undefined>
) =>
  useQuery(
    getUseUserAppointmentReadinessQueryKey(userId),
    () => {
      return UserApi.getUserAppointmentReadiness(userId, {
        provider_id: providerId,
      });
    },
    {
      staleTime: Infinity,
      ...options,
    }
  );
